import { Monitor } from "@mui/icons-material";
import { Box, Grid, Paper, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Station } from "../../data/models/product/ProductModel";
import { useStations } from "../hooks/useStations";

export default function StationsPage() {
  const { stations } = useStations();
  const navigate = useNavigate();

  const handleOpenStation = (station: Station) => {
    navigate(`/dashboard/stations/view?id=${station.id}`);
  };

  return (
    <Box
      sx={{
        px: { xs: 2, md: 4 },
        py: { xs: 3, md: 4 },
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent={"space-between"}
        gap={2}
        mb={3}
      >
        <Typography variant="h5" fontWeight={700}>
          Pantallas
        </Typography>
      </Stack>

      <Grid container spacing={2}>
        {stations.map((st) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={st.id}>
            <Paper
              elevation={2}
              sx={{
                p: 2,
                borderRadius: 2,
                cursor: "pointer",
                transition: "0.2s",
                height: 150,
                display: "flex",
                flexDirection: "column",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: 4,
                  backgroundColor: "rgba(0,0,0,0.03)",
                },
              }}
              onClick={() => handleOpenStation(st)}
            >
              <Monitor sx={{ fontSize: 32, color: "primary.main" }} />
              <Typography
                mt={1.5}
                fontSize={18}
                fontWeight={700}
                sx={{ textTransform: "capitalize" }}
              >
                {st.name}
              </Typography>
              {/* <Typography mt="auto" fontSize={13} color="text.secondary">
                ID: {st.id}
              </Typography> */}
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
